///
/// EarthBrowser
///
/// Sea Surface Temperature legend body: the overlay's color scale. The
/// gradient stops mirror sstPalette in shaders/overlay_sst.glsl - keep
/// the two in sync.
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///

import { ColorScale, LegendFootnote, gradientFromStops } from "./LegendPrimitives"

// Palette stops from overlay_sst.glsl: [deg C, css color]
const cPaletteStops: Array<[number, string]> = [
	[-2, "rgb(38, 0, 115)"],
	[4, "rgb(13, 38, 179)"],
	[10, "rgb(0, 115, 230)"],
	[16, "rgb(0, 191, 217)"],
	[21, "rgb(38, 204, 89)"],
	[25, "rgb(230, 222, 38)"],
	[29, "rgb(250, 140, 13)"],
	[32, "rgb(230, 38, 13)"],
	[35, "rgb(140, 0, 26)"],
]

const cMinC = cPaletteStops[0][0]
const cMaxC = cPaletteStops[cPaletteStops.length - 1][0]
const cGradient = gradientFromStops(cPaletteStops)

function percentFor(celsius: number): number {
	return ((celsius - cMinC) / (cMaxC - cMinC)) * 100
}

// No 30° tick: at this width it would run into the end label
const cTicks = [
	...[0, 10, 20].map(c => ({ at: percentFor(c), label: `${c}°` })),
	{ at: 100, label: `${cMaxC}°C` },
]

export function SstLegendContent() {
	return (
		<>
			<ColorScale gradient={cGradient} ticks={cTicks} />
			<LegendFootnote>
				Land and lakes are transparent. Data: NOAA Coral Reef Watch CoralTemp, daily 5 km analysis.
			</LegendFootnote>
		</>
	)
}
